<div class="input-group">
  @if (file || document?.id) {
    <label
      ngbTooltip="Consulter"
      placement="top"
      class="input-group-prepend mb-0 btn btn-primary cursor-pointer"
      (click)="consultFile()"
      >
      <fa-icon icon="eye"></fa-icon>
    </label>
  }
  <input type="text" class="form-control" [(ngModel)]="name" [class.is-invalid]="invalid" [class.bg-white]="!disabled" [attr.disabled]="true" />
  @if (!disabled) {
    <label class="input-group-append mb-0 btn btn-primary cursor-pointer rounded-end" ngbTooltip="Upload" placement="top">
      <fa-icon icon="upload"></fa-icon>
      <input (change)="onFileChange($event)" type="file" onclick="this.value = null" [accept]="accept || '*'" style="display: none" />
    </label>
  }
</div>
